/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Metric_CrumbInputs */

const en_progress_metric_crumb = /** @type {(inputs: Progress_Metric_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric`)
};

const pl_progress_metric_crumb = /** @type {(inputs: Progress_Metric_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametr`)
};

/**
* | output |
* | --- |
* | "Metric" |
*
* @param {Progress_Metric_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const progress_metric_crumb = /** @type {((inputs?: Progress_Metric_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Metric_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_progress_metric_crumb(inputs)
	return en_progress_metric_crumb(inputs)
});